import React, { useContext, useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { VscReferences } from "react-icons/vsc";


const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();

  const access_token = localStorage.getItem("token");
   
  const translations = {
    hi: {
      wallet: 'वॉलेट',
      history: 'इतिहास देखे | ',
      amount: 'पैसे जोड़ें | ',
      withdraw: 'पैसे निकाले  | ',
      referPerson: 'रेफ़रल | ',
    },
    en: {
      wallet: 'My Wallet',
      history: 'Order History',
      amount: 'Add Cash',
      withdraw: 'Withdraw',
      referPerson: 'Referral',
    },
  };

  const { language } = useContext(LanguageContext);


  // change theme 
  const theme = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : '#000',
    color: theme === 'light' ? 'black' : '#fff',
  };


  return (
    <>
      <div className="leftContainer mb_space" style={{ ...styles, height: "100vh" }}>
        <div className="Orher_page_main_section">
          

          <div className="wallet-section">
  <h3 className="wallet-title">Balance Overview</h3>

            <div className="row">

              {/* Deposit Card */}
              <div className="col-md-12 mb-3">
                <div className="wallet-modern-card deposit-card">

                  <div className="wallet-card-top">
                    <div className="wallet-icon-box">
                      <img src="/images/deposit.png" alt="" />
                    </div>

                    <div>
                      <h2>Deposit Cash</h2>
                      <p>Play Battles & Tournaments</p>
                    </div>
                  </div>

                  <div className="wallet-balance">
                    <img
                      src="/images/rupee.png"
                      alt=""
                      className="rupee-icon"
                    />

                    <span>
                      {user && user.Wallet_balance - user.withdrawAmount}
                    </span>
                  </div>

                  <Link to="/addcase" className="wallet-btn deposit-btn">
                    <AiOutlinePlus className="mr-2" />
                    Add Amount
                  </Link>
                </div>
              </div>

              {/* Winning Card */}
              <div className="col-md-12 mb-3">
                <div className="wallet-modern-card winning-card">

                  <div className="wallet-card-top">
                    <div className="wallet-icon-box">
                      <img src="/images/win-cash.png" alt="" />
                    </div>

                    <div>
                      <h2>Winning Cash</h2>
                      <p>Withdraw Anytime</p>
                    </div>
                  </div>

                  <div className="wallet-balance winning-balance">
                    <img
                      src="/images/rupee.png"
                      alt=""
                      className="rupee-icon"
                    />

                    <span>
                      {user && user.withdrawAmount}
                    </span>
                  </div>

                  <Link
                    to="/Withdrawopt"
                    className="wallet-btn withdraw-btn"
                  >
                    <BsWallet2 className="mr-2" />
                    Withdraw
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
